import { Component } from 'react';
import { Link } from 'react-router-dom';
class UsefulLink extends Component {
    render() {
        return (
            <div className="widget widget-services">
                <ul className="one-half first">
                    <li><Link to="/" title="">Home</Link></li>
                    <li><Link to="/about-v1" title="">Who We Are</Link></li>
                    <li><Link to="/services-v1" title="">What We Do</Link></li>
                </ul>
                {/* <!-- /.one-half --> */}
                <ul className="one-half">
                    <li><Link to="/blog" title="">Resources</Link></li>
                    <li><Link to="/contact-v1" title="">Talk to Us</Link></li>
                </ul>
                {/* <!-- /.one-half --> */}
            </div>
        /* <!-- /.widget-services --> */
        );
    }
}

export default UsefulLink;
